import { useState, useEffect } from 'react'
import { Box, Avatar, Typography } from '@mui/material'
import { useHistory } from 'react-router-dom'
import { userButtonList } from '../../../components/utils/buttonList'
import CustomerAdminUserActionBtn from '../../../components/Buttons/CustomerAdminUserActionBtn.jsx'
import { getFirstAndSecondCharacterOnly } from '../../../utils/helpers'
import UseTranslation from '../../../hooks/UseTranslation.jsx'
import HoverTooltip from '../../../components/PageHelpers/HoverTooltip.jsx'

const CustomerAdminUsersCard = ({ user, customStyle }) => {
  const baseUri = process.env.REACT_APP_ROOT_ROUTE || ''
  const history = useHistory()
  const [status, setStatus] = useState(false)
  const { t } = UseTranslation()
  useEffect(() => {
    if (user?.active) setStatus(userButtonList[0])
    else setStatus(userButtonList[1])
  }, [user])
  const userProfileHandler = () => {
    history.push(`${baseUri}/user/${user.id}`)
  }
  return (
    <Box sx={[styles.singleCard, customStyle && customStyle]}>
      <Box sx={styles.info} onClick={userProfileHandler}>
        <Box>
       <Avatar sx={styles.avatar}>
        {getFirstAndSecondCharacterOnly(user?.name)}
       </Avatar>
        </Box>
        <Box sx={styles.infoContainer}>
        <Box sx={styles.nameUnit}>
            <Typography component={'span'}>{`${t?.['User Name']}`}</Typography>
            <HoverTooltip title={user?.name || `${t?.['No User Name']}`}>
            <Typography variant='body1'>
          { user?.name || `${t?.['No User Name']}`}
            </Typography>
            </HoverTooltip>
        </Box>
        <Box sx={styles.infoUnit}>
            <Typography component={'span'}>{`${t?.email}`}</Typography>
            <HoverTooltip title={user?.email}>
            <Typography variant='body1'>
            {user?.email}
         </Typography>
            </HoverTooltip>
        </Box>
        <Box sx={styles.infoUnit}>
            <Typography component={'span'}>{`${t?.['User Type']}`}</Typography>
            <HoverTooltip title={user?.user_types}>
            <Typography variant='body1'>
          {user?.user_types}
            </Typography>
            </HoverTooltip>
        </Box>
        <Box sx={styles.infoUnit}>
            <span>{`${t?.Status}`}</span>
            <HoverTooltip title={status?.title}>
          <Box sx={{ color: status?.color }}>{status?.title}</Box>
            </HoverTooltip>
        </Box>
        </Box>
      </Box>
      <CustomerAdminUserActionBtn user={user} customStyle={styles.actionBtn} />
    </Box>
  )
}

const styles = {
  singleCard: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'white',
    fontSize: { xs: '14px', md: '16px' },
    padding: { xs: '10px 20px 10px 10px', md: '0px 20px' },
    margin: { xs: '10px', md: '10px 0' },
    borderRadius: '12px',
    boxShadow: '0 1px 3px 0 #efefef, 0 0 0 1px #f1f1f1',
    position: { xs: 'relative', md: 'unset' },
    height: { xs: 'unset', md: '110px' },
  },
  info: {
    display: 'flex',
    flexDirection: { xs: 'row', md: 'row' },
    justifyContent: 'space-between',
    alignItems: { xs: 'center', md: 'center' },
    width: { xs: '90%', md: '100%' },
    cursor: 'pointer',
  },
  avatar: {
    display: 'flex',
    bgcolor: '#FFC542',
    color: 'white',
    height: { xs: '50px', md: '64px' },
    width: { xs: '50px', md: '64px' },
    mr: { xs: '0px', md: '29px' },
    textTransform: 'uppercase',
    fontWeight: 800,
    fontSize: { xs: '16px', md: '25px' },
  },
  infoContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    marginLeft: { xs: '10px', md: '0px' },
  },
  nameUnit: {
    display: 'flex',
    flexDirection: { xs: 'row', md: 'column' },
    justifyContent: { xs: 'flex-start', md: 'center' },
    maxWidth: { xs: '90%', sm: '180px' },
    width: '100%',
    alignItems: 'flex-start',
    '& p': {
      fontSize: { xs: '12px', md: '16px' },
      whiteSpace: { xs: 'unset', md: 'nowrap' },
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: 'fit-content',
      maxWidth: { xs: '90%', md: '95%' },
      fontWeight: { xs: '600', md: '500' },
    },
    '& span': {
      display: { xs: 'none', md: 'block' },
      width: 'fit-content',
      fontSize: { xs: '12px', md: '14px' },
      opacity: '0.7',
      fontWeight: '500',
      color: 'text.hint',
      marginBottom: '10px',
      marginRight: { xs: '10px', md: '0px' },
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  infoUnit: {
    display: 'flex',
    flexDirection: { xs: 'row', md: 'column' },
    justifyContent: { xs: 'flex-start', md: 'center' },
    maxWidth: { xs: '90%', sm: '180px' },
    width: '100%',
    alignItems: 'flex-start',
    '& p': {
      fontSize: { xs: '12px', md: '16px' },
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: 'fit-content',
      maxWidth: { xs: '100%', md: '95%' },
      marginBottom: { xs: '5px', md: '0px' },
    },
    '& span': {
      display: { xs: 'none', md: 'block' },
      width: '85%',
      fontSize: { xs: '12px', md: '14px' },
      opacity: '0.7',
      fontWeight: '500',
      color: 'text.hint',
      marginBottom: '10px',
      marginRight: { xs: '10px', md: '0px' },
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  actionBtn: {
    position: { xs: 'absolute', md: 'unset' },
    top: { xs: '10px', md: 'unset' },
    right: { xs: '10px', md: 'unset' },
  },
}
export default CustomerAdminUsersCard
